import { CardBody, CardTitle, Card, Col } from 'reactstrap';
import Spin from 'antd/lib/spin';
import { LoadingOutlined } from '@ant-design/icons';

const SingleMatrixCard = ({
  cardTitle,
  subTitle,
  data,
  isLoading,
  error,
  errorMessage = 'Error Occured',
  color = '',
  suffix,
  prefix,
  isClickable,
  clickHandler,
  isActive = false,
}) => (
  <Col>
    <Card
      style={{
        border: '2px solid #dedee1',
        borderRadius: '10px',
        boxShadow: isActive ? '5px 5px #808080' : '5px 5px #dedee1',
        cursor: isClickable ? 'pointer' : '',
        margin: '5px',
      }}
      // onClick={clickHandler}
    >
      {/* <Statistic
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '.8125rem',
              fontWeight: '600',
              color: '#8898aa',
            }}
          >
            <div style={{ textTransform: 'uppercase' }}>
              {error ? errorMessage : cardTitle}
            </div>
            {subTitle && (
              <div style={{ fontSize: '10px', marginLeft: '2px' }}>
                {subTitle}
              </div>
            )}
          </div>
        }
        value={data || 0}
        prefix={prefix}
        suffix={suffix}
        loading={isLoading}
        valueStyle={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color,
          fontSize: '28px',
        }}
      /> */}
      <CardBody>
        <div
          className="col"
          style={{
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <CardTitle
            tag="h5"
            className="text-uppercase text-muted text-center mb-0"
          >
            {cardTitle}
          </CardTitle>
          <span
            className="h1 font-weight-bold text-center mb-0"
            style={{ fontSize: '30px', color }}
          >
            {prefix && prefix}
            {isLoading ? (
              <Spin
                spinning={isLoading}
                size="large"
                // className={classes.antSpinner}
                indicator={
                  <LoadingOutlined style={{ color: '#2675b8', fontSize: 17 }} />
                }
              />
            ) : error ? (
              'Error occured'
            ) : (
              data || 0
            )}{' '}
            {suffix && suffix}
          </span>
        </div>
      </CardBody>
    </Card>
  </Col>
);

export default SingleMatrixCard;
